// Compiled by `pnpm build` into assets/built/index.js and index.css.
import "../css/index.css";

import menu from "./menu";
import sidenotes from "./sidenotes";
import tables from "./tables";
import publications from "./publications";
import viz from "./viz";
import contact from "./contact";
import publicationPage from "./publication-page";
import services from "./services";

menu();
sidenotes();
tables();
publications();
viz();
contact();
publicationPage();
services();
